import { HTTPClient } from "./Client";

const AlunoApi = {

    async editarAlunoAsync(alunoId, nomeCompleto, nomeContato, cpf, rg, dataDeNascimento, status) {
        const aluno = {
            nomeCompleto: nomeCompleto,
            nomeContato: nomeContato,
            cpf: cpf,
            rg: rg,
            dataDeNascimento: dataDeNascimento,
            status: Number(status)
        }

        const response = await HTTPClient.put(`/Aluno/AtualizarAluno/${alunoId}`, aluno);
        return response.data;
    },

    async criarAlunoAsync(nomeCompleto, nomeContato, cpf, rg, dataDeNascimento, email, senha, confirmarSenha) {
        const alunoCriar = {
            NomeCompleto: nomeCompleto,
            NomeContato: nomeContato,
            Cpf: cpf,
            Rg: rg,
            DataDeNascimento: dataDeNascimento,
            Email: email,
            Senha: senha,
            ConfirmarSenha: confirmarSenha
        }

        await HTTPClient.post(`/Aluno/AdicionarAluno`, alunoCriar);
    },

    async listarAlunosAsync(pagina, nome, email) {
        const alunosComPaginacao = {
            Pagina: pagina,
            Nome: nome,
            Email: email
        };


        const response = await HTTPClient.post(`/Aluno/ListarAlunos`, alunosComPaginacao);
        return response.data;
    },

    async ObterAlunoPorPessoaId(alunoId) {
        const response = await HTTPClient.get(`/Aluno/ObterAlunoPorId/${alunoId}`);
        return response.data;
    },

    async listarStatusAlunosAsync() {
        const response = await HTTPClient.get(`/Usuario/ListarStatusUsuario`);
        return response.data;
    },
    async deletarAlunoAsync(alunoId) {
        await HTTPClient.put(`/Aluno/DeletarAluno/${alunoId}`);
    },

    async restaurarAlunoAsync(alunoId) {
        await HTTPClient.put(`/Aluno/RestaurarAluno/${alunoId}`);
    },

    async ListarAlunosComTurmaMonitor(pagina, tamanhoPagina, nome, email){
        const alunosComTurmaMonitor = await HTTPClient.get(`/Aluno/ListarAlunosComTurmaMonitor`, {
            params: {
                Pagina: pagina,
                TamanhoPagina: tamanhoPagina,
                Nome: nome,
                Email: email
            }
        });
        return alunosComTurmaMonitor.data;
    },

    async ListarAlunosComOuSemTurmaMonitor(pagina, tamanhoPagina, nome, email, tipoConsulta){
        const alunosComOuSemTurmaMonitor = await HTTPClient.get(`/Aluno/ListarAlunosComOuSemTurmaMonitor`, {
            params: {
                Pagina: pagina,
                TamanhoPagina: tamanhoPagina,
                Nome: nome,
                Email: email,
                TipoConsulta: tipoConsulta
            }
        });
        return alunosComOuSemTurmaMonitor.data;
    }
}

export default AlunoApi;